<script>

import mapboxgl from 'mapbox-gl';
import * as turf from "@turf/turf";

export default {
  name: 'Map',
  compatConfig: {
    MODE: 2, // opt-in to Vue 3 behavior for this component only
    FEATURE_ID_A: true, // features can also be toggled at component level
  },

  mixins: [],

  props: {
    vSource: {
      required: false,
      type: Object,
      default: function () {
        return {};
      },
    },
    vCenter: {
      required: false,
      type: Array,
      default: function(){
        return [-93.627594, 42.025494];
      },
    },
    mapId: {
      required: true,
      type: String,
      default: ''
    }
  },

  computed: {
    center() {
      if (this.vCenter) {
        return this.vCenter;
      }
      return [-93.627594, 42.025494];
    }
  },

  watch: {
    vSource: function () {
      if (!(this.boundary === this.vSource)) {
        this.renderMap();
      }
    },
  },

  data() {
    return {
      accessToken: 'pk.eyJ1IjoibWFya2xhbWJlcnQiLCJhIjoiY2tqaXN6cW1qMWhwejJxbXM1NWd2bmZ6dyJ9.ZxZfA5qims01_Y4w0QKbGg',
      mapStyle: 'mapbox://styles/mapbox/satellite-streets-v11',
      map: {},
      boundary: "",
      fullBounds: {},
    };
  },

  mounted() {
    this.renderMap();
  },

  methods: {

    renderMap: function () {
      this.boundary = this.vSource;
      this.createMap();
      this.map.scrollZoom.disable();
      this.addControls();

      // Add layer when map is loaded
      let loading = true;
      this.map.on('load', function () {
        loading = false;
        this.map.resize()
      }.bind(this));

      if (this.boundary != null) {

        const delay = ms => new Promise(res => setTimeout(res, ms));

        const addFieldLayer = async () => {
          if (!loading) {
            this.postMapRender();
            clearInterval(loader);
          } else {
          }
        };
        let loader = setInterval(addFieldLayer, 500);

      }
    },

    createMap: function () {
      mapboxgl.accessToken = this.accessToken;

      let center = this.vCenter

      if (!center) {
        center = [-93.627594, 42.025494];
      }

      this.map = new mapboxgl.Map({
        container: this.mapId,
        style: this.mapStyle, // stylesheet location
        center: center,
        zoom: 3, // starting zoom
        transformRequest: (url, resourceType) => {
          if (resourceType === 'Source' && url.startsWith('https://gis.apfo.usda.gov')) {
            return {
              url: url,
              headers: { 'Access-Control-Allow-Origin': true }
            }
          }
        }
      });

      this.fullBounds = new mapboxgl.LngLatBounds();
    },

    postMapRender: function () {
      let data = this.boundary

      if (data != null) {
        let fieldGeometry = data
        this.map.addLayer({
          'id': 'fieldBoundary',
          'type': 'fill',
          'source': {
            'type': 'geojson',
            'data': fieldGeometry
          },
          'layout': {},
          'paint': {
            'fill-color': '#008ED3',
            'fill-opacity': 0.5
          }
        });

        let bbox = turf.bbox(fieldGeometry);

        this.fullBounds.extend([bbox[0], bbox[1]]);
        this.fullBounds.extend([bbox[2], bbox[3]]);

        this.map.fitBounds(this.fullBounds, {
          padding: 30
        });
      }

    },

    addControls: function () {
      // Add zoom and rotation controls to the map.
      this.map.addControl(new mapboxgl.NavigationControl());
    },

    /**
     * Sets the bounds of a map to fit the given geography.
     */
    setMapBoundsToFit(geography) {
      this.fullBounds = new mapboxgl.LngLatBounds();
      let bbox = turf.bbox(geography);

      this.fullBounds.extend([bbox[0], bbox[1]]);
      this.fullBounds.extend([bbox[2], bbox[3]]);

      this.map.fitBounds(this.fullBounds, {
        padding: 10,
        duration: 0,
      });
    },

  },
};

</script>

<template>
  <div :id="mapId" class="w-full"></div>
</template>
